import {useEffect,useState} from 'react';

// Device-local presentation preferences never change the saved edit.
export default function useLayoutPreference(key,defaultEnabled=false) {
  const [enabled,setEnabled]=useState(()=>{
    try{
      const saved=localStorage.getItem(key);
      return saved===null?defaultEnabled:saved==='true';
    }catch{return defaultEnabled;}
  });
  useEffect(()=>{
    try{localStorage.setItem(key,String(enabled));}catch{/* Still usable when storage is unavailable. */}
  },[key,enabled]);
  return [enabled,setEnabled];
}
